import React from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { FileUpload } from "primereact/fileupload";
import { ProgressSpinner } from "primereact/progressspinner";
import config from "../../../config";

// Component for editing a paper info
const EditPaperInfoForm = ({
  visible,
  onHide,
  editedPaperInfo,
  syllabusOptions,
  mediumOptions,
  gradeOptions,
  subjectOptions,
  paperTypeOptions,
  onInputChange,
  handleFileUpload,
  handleClearImage,
  fileUploadRef,
  filePreview,
  saveEditedPaperInfo,
  loading,
}) => {
  return (
    <Dialog
      header="Edit Paper Info"
      visible={visible}
      onHide={onHide}
      style={{ width: "900px", maxHeight: "700px" }}
    >
      <div className="p-fluid">
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="syllabusId">Syllabus</label>
            <Dropdown
              id="syllabusId"
              name="syllabusId"
              value={editedPaperInfo.syllabusId}
              options={syllabusOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="mediumId">Medium</label>
            <Dropdown
              id="mediumId"
              name="mediumId"
              value={editedPaperInfo.mediumId}
              options={mediumOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="gradeId">Grade</label>
            <Dropdown
              id="gradeId"
              name="gradeId"
              value={editedPaperInfo.gradeId}
              options={gradeOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="subjectId">Subject</label>
            <Dropdown
              id="subjectId"
              name="subjectId"
              value={editedPaperInfo.subjectId}
              options={subjectOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="paperTypeId">Paper Type</label>
            <Dropdown
              id="paperTypeId"
              name="paperTypeId"
              value={editedPaperInfo.paperTypeId}
              options={paperTypeOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="paperInfo">Paper Info</label>
            <InputText
              id="paperInfo"
              name="paperInfo"
              value={editedPaperInfo.paperInfo}
              onChange={onInputChange}
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div className="p-field" style={{ marginBottom: "20px" }}>
          <label htmlFor="image">Image</label>
          <FileUpload
            ref={fileUploadRef}
            name="image"
            accept="image/*"
            chooseLabel="Upload"
            uploadLabel="Upload"
            mode="basic"
            customUpload
            onSelect={handleFileUpload}
            style={{ marginTop: "10px" }}
          />
          {filePreview && (
            <>
              <img
                src={filePreview}
                alt="Uploaded"
                style={{ maxWidth: "150px", marginTop: "10px" }}
              />
              <i
                className="pi pi-times-circle"
                onClick={handleClearImage}
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  verticalAlign: "middle",
                  fontSize: "1rem",
                  color: "#bb2124",
                }}
              ></i>
            </>
          )}
          {!filePreview && editedPaperInfo.image && (
            <>
              <img
                src={`${config.apiUrl}/uploads/${editedPaperInfo.image}`}
                alt="ExistingImage"
                style={{ maxWidth: "150px", marginTop: "10px" }}
              />
              <div
                style={{
                  maxWidth: "150px",
                  marginTop: "10px",
                  color: "#198754",
                }}
              >
                <b>
                  <center>{editedPaperInfo.image}</center>
                </b>
              </div>
            </>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="visibility">Visibility</label>
          <br></br>
          <RadioButton
            id="visibility"
            name="visibility"
            value={true}
            onChange={onInputChange}
            checked={editedPaperInfo.visibility === true}
            style={{ marginTop: "10px" }}
          />{" "}
          Yes &nbsp;
          <RadioButton
            id="visibility"
            name="visibility"
            value={false}
            onChange={onInputChange}
            checked={editedPaperInfo.visibility === false}
            style={{ marginTop: "10px" }}
          />{" "}
          No
        </div>
      </div>
      <div
        className="p-dialog-footer"
        style={{
          marginTop: "20px",
          marginBottom: "-20px",
          marginRight: "-24px",
        }}
      >
        <Button label="Cancel" onClick={onHide} severity="danger" outlined />
        <Button
          label={
            loading ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                Saving...&nbsp;&nbsp;
                <ProgressSpinner
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                />
              </div>
            ) : (
              "Save"
            )
          }
          onClick={saveEditedPaperInfo}
          severity="success"
          outlined
          disabled={loading}
        />
      </div>
    </Dialog>
  );
};

export default EditPaperInfoForm;
